'use strict';

define(['utils/helpers', 'utils/underscore'], function (utils, _) {
    /*global __webpack_public_path__:true*/

    // Defaults
    var Defaults = {
        //androidhls: true,
        autostart: false,
        controls: true,
        keyControls: true,
        displaytitle: true,
        displaydescription: true,
        mobilecontrols: false,
        repeat: false,
        castAvailable: false,
        skin: 'bce',
        stretching: 'uniform',
        mute: false,
        volume: 100,
        width: 480,
        height: 270,
        controlbar: {
            barLogo: true,
            barLogoUrl: 'https://cloud.baidu.com/solution/media.html',
            canDrag: true // 是否允许拖动滚动条
        },
        marquee: {
            show: false,
            text: '百度云',
            fontSize: 12,
            color: '#FFF'
        },
        startseek: true, // 是否根据上一次播放时间跳转
        flashUI: false, // 是否强制使用flashUI
        playRate: true,
        playbackRate: 1, // 默认1倍速
        playRateConfig: [{ label: '×1' }, { label: '×1.5' }, { label: '×2' }, { label: '×3' }, { label: '×4' }, { label: '×5' }],
        isLive: false, // 默认是点播
        allowDoubleClickFullscreen: true, // 允许双击全屏
        allowClickToDisplay: true,
        retryCount: 0,
        tokenEncrypt: false, // 是否是hls token加密方式
        crossoriginAnonymous: false,
        withLog: true // 是否记录日志，可以设置false来关闭日志功能
    };

    function _deserialize(options) {
        _.each(options, function (val, key) {
            options[key] = utils.serialize(val);
        });
    }

    function _normalizeSize(val) {
        if (val.slice && val.slice(-2) === 'px') {
            val = val.slice(0, -2);
        }
        return val;
    }

    // 低版本IE参数设置
    function setPoorIEConfig(options) {
        // 如果小于7，flashUI = true
        if (utils.isMSIE(7) || utils.isMSIE(6)) {
            options.flashUI = true;
        }
        options.skin = 'bce';
        options.startseek = false;
        delete options.skinColorInactive;
        delete options.skinColorActive;
        delete options.skinColorBackground;
        return options;
    }

    var config = function config(options, storage) {

        // 兼容老参数
        if (options.autoStart) {
            options.autostart = true;
        }
        if (options.controls === 'over' || options.controls === 'none') {
            options.controls = options.controls === 'over';
        }
        if (options.startParam) {
            options.startparam = options.startParam;
        }

        var persisted = storage && storage.getAllItems();
        var allOptions = _.extend({}, (window.jwplayer || {}).defaults, persisted, options);

        _deserialize(allOptions);

        var config = _.extend({}, Defaults, allOptions);
        config.options = options;
        // 默认可拖动时间条
        if (config.controlbar.canDrag === undefined) {
            config.controlbar.canDrag = true;
        }
        if (config.base === '.') {
            config.base = utils.getScriptPath('cyberplayer.js');
        }
        if (!config.playRate) {
            // 如果不显示倍速，则倍速永远是1
            config.playbackRate = 1;
        }
        config.base = (config.base || utils.loadFrom()).replace(/\/?$/, '/');
        __webpack_public_path__ = config.base;
        config.width = _normalizeSize(config.width);
        config.height = _normalizeSize(config.height);
        config.flashplayer = config.flashplayer || utils.getScriptPath('cyberplayer.js') + 'cyberplayer.flash.swf';

        // Non ssl pages can only communicate with flash when it is loaded
        //   from a non ssl location
        if (window.location.protocol === 'http:') {
            config.flashplayer = config.flashplayer.replace('https', 'http');
        }

        config.aspectratio = _evaluateAspectRatio(config.aspectratio, config.width);

        if (_.isObject(config.skin)) {
            config.skinUrl = config.skin.url;
            config.skinColorInactive = config.skin.inactive; // default icon color
            config.skinColorActive = config.skin.active; // icon hover, on, slider color
            config.skinColorBackground = config.skin.background; // control elements background
            config.skin = _.isString(config.skin.name) ? config.skin.name : Defaults.skin; // get skin name if it exists
        }

        if (_.isString(config.skin) && config.skin.indexOf('.xml') > 0) {
            console.log('JW Player does not support XML skins, please update your config');
            config.skin = config.skin.replace('.xml', '');
        }

        if (!config.aspectratio) {
            delete config.aspectratio;
        }

        if (!config.playlist) {
            // This is a legacy fallback, assuming a playlist item has been flattened into the config
            var obj = _.pick(config, ['title', 'description', 'type', 'mediaid', 'image', 'file', 'sources', 'tracks', 'preload', 'fallbackfile' // 备用播放地址
            ]);

            config.playlist = [obj];
        }

        // 如果是低版本ie
        if (utils.isPoorIE()) {
            config = setPoorIEConfig(config);
        }

        // 如果是chrome66版本以上，声音默认先设为空
        if (utils.isChrome66()) {
            config.originVolume = config.volume;
            config.volume = 0;
        }

        return config;
    };

    function _evaluateAspectRatio(ar, width) {
        if (width.toString().indexOf('%') === -1) {
            return 0;
        }
        if (typeof ar !== 'string' || !utils.exists(ar)) {
            return 0;
        }
        if (/^\d*\.?\d+%$/.test(ar)) {
            return ar;
        }
        var index = ar.indexOf(':');
        if (index === -1) {
            return 0;
        }
        var w = parseFloat(ar.substr(0, index)),
            h = parseFloat(ar.substr(index + 1));
        if (w <= 0 || h <= 0) {
            return 0;
        }
        return h / w * 100 + '%';
    }

    return config;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/api/config.js
 ** module id = 67
 ** module chunks = 0
 **/